/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import SubmitButton from '../../components/SubmitButton';
import convertToCurrency from '../../helpers/convertToCurrency';
import { Accordion } from '../../components/Accordion';
import { CollapsibleLineItems, LineItemRow } from '../../components/CollapsibleLineItems';
import { OwnershipTimeline } from '../../components/OwnershipTimeline';
import { FAQdata } from './FAQdata';
import receiptIcon from '../../assets/img/kplus-receipt.png';
import repeatIcon from '../../assets/img/kplus-repeat.png';
import { KATAPULT_BOOST_PRICE } from '../../helpers/kplusPricing';

// Label with a muted "(optional)" suffix, matching the design.
const optionalLabel = name => (
  <>
    {name} <span className="k-line-item-optional">(optional)</span>
  </>
);

export function DisplayOfferedLeaseDetailsB({
  store,
  getPeriod,
  checkoutData,
  isPromoExist,
  handleSubmit,
  onSubmit,
  isValid,
  loading,
  isRbpPromo,
  hasGiftCardPromo,
  giftCardAmountDisplay,
  isKplusAvailable,
  kplusMonthlyPrice,
  isBoostAvailable,
  vofSavingAmount = 0,
}) {
  const [showGiftCardTerms, setShowGiftCardTerms] = useState(false);
  const strikeThroughAmount = store?.checkout?.original_due_today;
  const initialPaymentAmount = Number.parseFloat(store?.checkout?.initial_payment) || 0;
  const processingFeeAmount = Number.parseFloat(store?.checkout?.processing_fee) || 0;
  // When there's no initial payment due but a processing fee applies, the Initial Payment row
  // shows the processing fee instead - otherwise the row would just read "$0.00".
  let initialPaymentDisplayAmount = store?.checkout?.initial_payment;
  if (initialPaymentAmount === 0 && processingFeeAmount > 0) {
    initialPaymentDisplayAmount = store?.checkout?.processing_fee;
  }

  const formattedPromoSavings = `$${vofSavingAmount.toLocaleString('en-US')}`;

  const dueTodayTotal = isRbpPromo ? (
    <>
      <span className="k-due-today-strike">{convertToCurrency(strikeThroughAmount)}</span>
      <span className="k-promotion-amount">{convertToCurrency(store?.checkout?.due_today) || '$0.00'}</span>
    </>
  ) : (
    convertToCurrency(store?.checkout?.due_today) || '$0.00'
  );

  // Under the RBP promo, the Initial Payment row itself shows the same strike-through
  // treatment as the card total above: rbp_base_fee is the undiscounted price, while
  // initial_payment is what the customer actually pays.
  const initialPaymentValue = isRbpPromo ? (
    <>
      <span className="k-due-today-strike">{convertToCurrency(store?.checkout?.rbp_base_fee)}</span>
      <span className="k-promotion-amount">{convertToCurrency(initialPaymentDisplayAmount) || '$0.00'}&#x1F525;</span>
    </>
  ) : (
    convertToCurrency(initialPaymentDisplayAmount) || '$0.00'
  );

  const dueTodayIcon = <img src={receiptIcon} alt="" className="k-collapsible-card__icon-img" />;

  const recurringPaymentsIcon = <img src={repeatIcon} alt="" className="k-collapsible-card__icon-img" />;

  // The Katapult Protection+ FAQ entry only makes sense when the plan itself is available.
  const faqItems = FAQdata.filter(item => {
    if (item.title === 'What is Katapult Protection+?') return isKplusAvailable;
    if (item.title === 'What is Katapult Boost?') return isBoostAvailable;
    return true;
  });

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <h1 className="version-b">Hi, {store.firstName}! Begin your lease today!</h1>
      </section>

      {isRbpPromo && !hasGiftCardPromo && vofSavingAmount > 0 && (
        <div className="k-info margin-bottom-20">
          <div className="k-promotion">
            <span className="k-promotion-limited-badge">
              Limited
              <br />
              Offer
            </span>
            <h1>
              Save <span className="k-promotion-amount">{formattedPromoSavings}</span> on your Initial Payment
            </h1>
          </div>
        </div>
      )}

      {hasGiftCardPromo && (
        <div className="gift-card-section">
          <div className="gift-card-banner">
            <div className="gift-card-banner__badge">
              Limited
              <br />
              Offer
            </div>
            <div className="gift-card-banner__main">
              <div className="gift-card-banner__headline-top">
                {isRbpPromo
                  ? `Save $${vofSavingAmount.toLocaleString('en-US')} today + get a`
                  : 'Checkout today, get a'}
              </div>
              <div className="gift-card-banner__row">
                <div className="gift-card-banner__headline-bottom">
                  <span className="gift-card-banner__amount">{giftCardAmountDisplay}</span> Gift Card*
                </div>
                <button
                  className="gift-card-banner__toggle"
                  type="button"
                  onClick={() => setShowGiftCardTerms(prev => !prev)}
                >
                  <span className="gift-card-banner__toggle-text">
                    {showGiftCardTerms ? 'Hide Terms' : 'View Terms'}
                  </span>
                  <span
                    className={`gift-card-banner__arrow${showGiftCardTerms ? ' gift-card-banner__arrow--up' : ''}`}
                  />
                </button>
              </div>
            </div>
            {showGiftCardTerms && (
              <ul className="gift-card-banner__terms">
                <li>
                  You must make all lease payments on time for 90 consecutive days and remain in good standing to
                  qualify for a {giftCardAmountDisplay} digital Visa gift card.
                </li>
                <li>
                  The gift card will be sent via email at the end of the calendar month following the 90-day period.
                </li>
                <li>Limit one gift card per lease agreement.</li>
              </ul>
            )}
          </div>
        </div>
      )}

      {isPromoExist && (
        <div className="k-info margin-bottom-20">
          <div className="k-promotion">
            <span className="k-promotion-limited-badge">{store?.promotion?.banner || 'Promo offer just for you!'}</span>
            <h1>{store?.promotion?.metadata?.promo_banner_header || 'Demo Paragraph Text'}</h1>
          </div>
        </div>
      )}

      <section className="k-approve-wrapper">
        <CollapsibleLineItems icon={dueTodayIcon} title="Due today" subtitle="Due at checkout" total={dueTodayTotal}>
          <LineItemRow label="Initial payment" value={initialPaymentValue} />
          {store?.checkout?.downpayment && store?.checkout?.downpayment_amount && (
            <LineItemRow
              label="Lease Cost Reduction"
              value={`${convertToCurrency(store?.checkout?.downpayment_amount)}`}
            />
          )}
          {isRbpPromo && (
            <div className="k-flash-offer-row">
              <span className="k-flash-offer-tag">Flash Offer!</span>
            </div>
          )}
          {Number.parseFloat(store?.checkout?.shipping) > 0 && (
            <LineItemRow label="Shipping" value={convertToCurrency(store?.checkout?.shipping) || '$0.00'} />
          )}
          {Number.parseFloat(store?.checkout?.non_leasable_item_amount) > 0 && (
            <LineItemRow
              label="Non-leasable items"
              value={convertToCurrency(store?.checkout?.non_leasable_item_amount) || '$0.00'}
            />
          )}
          {Number.parseFloat(store?.checkout?.tax_due_checkout) > 0 && (
            <LineItemRow label="Tax" value={convertToCurrency(store?.checkout?.tax_due_checkout) || '$0.00'} />
          )}
          {isKplusAvailable && <LineItemRow label={optionalLabel('Katapult Protection +')} value={kplusMonthlyPrice} />}
          {isBoostAvailable && <LineItemRow label={optionalLabel('Katapult Boost')} value={KATAPULT_BOOST_PRICE} />}
        </CollapsibleLineItems>

        <CollapsibleLineItems
          icon={recurringPaymentsIcon}
          title="Recurring payments"
          subtitle="What you'll pay while your lease is active"
        >
          <LineItemRow
            label="Lease payment"
            value={`${(convertToCurrency(store?.checkout?.monthly_total) || '$0.00').trim()}/${
              getPeriod() || store.payFrequency || 'weekly'
            }`}
          />
          {isKplusAvailable && (
            <LineItemRow label={optionalLabel('Katapult Protection +')} value={`${kplusMonthlyPrice}/month`} />
          )}
          {isBoostAvailable && (
            <LineItemRow label={optionalLabel('Katapult Boost')} value={`${KATAPULT_BOOST_PRICE}/month`} />
          )}
        </CollapsibleLineItems>
        <OwnershipTimeline
          cashPrice={store?.checkout?.leasable_cash_price ?? store?.checkout?.cart_total}
          purchase90={checkoutData.earlyPurchase.total90}
          fullTerm={checkoutData.costOfOwnership}
          termMonths={store?.checkout?.term}
        />
      </section>
      <section className="k-info margin-top-20 leftAlign">
        <h2 className="k-faq-heading">Frequently asked questions</h2>
        <div className="k-faq-list">
          {faqItems.map(item => (
            <Accordion key={item.title} data={item} />
          ))}
        </div>
      </section>
      <section className="k-form k-form-indent">
        <form onSubmit={handleSubmit(onSubmit)}>
          <SubmitButton grey={!isValid} text="Continue" loading={loading} />
        </form>
      </section>
    </div>
  );
}
